import { useState } from 'react';
import { TableInput } from '../../../../../components/common';
import formatDate from '../../../../../components/common/formatDate';
import DatePickerMui from '../../../../../components/common/DatePickerMui';
import moment from 'moment';

interface IProps {
  moduleData: any;
  isView: boolean;
}
const TFoot = ({ isView, moduleData }: IProps) => {
  const [render, setRender] = useState(false);
  return (
    <tfoot>
      {/* <tr>
        <th align="left" colSpan={18}>
          Status:
          <TableInput
            isView={isView}
            name="status"
            type="text"
            value={moduleData?.status}
            onChange={(e) => {
              moduleData.status = e.target.value;
              setRender((prev) => !prev);
            }}
          />
        </th>
      </tr> */}
      <tr>
        <th colSpan={4} align="left">
          OPERATOR NAME/SIGN:
          <TableInput
            isView={isView}
            name="batch_no"
            type="text"
            value={moduleData?.inspected_by}
            onChange={(e) => {
              moduleData.inspected_by = e.target.value;
              setRender((prev) => !prev);
            }}
          />
        </th>
        <th colSpan={6} align="left">
          QC Inspector NAME/SIGN:
          <TableInput
            isView={isView}
            name="approved_by"
            type="text"
            value={moduleData?.approved_by}
            onChange={(e) => {
              moduleData.approved_by = e.target.value;
              setRender((prev) => !prev);
            }}
          />
        </th>
        <th colSpan={4} align="left">
          Reviewd by (FRQ. 1/WEEK ) :
          <TableInput
            isView={isView}
            name="reviewed_by"
            type="text"
            value={moduleData?.reviewed_by}
            onChange={(e) => {
              moduleData.reviewed_by = e.target.value;
              setRender((prev) => !prev);
            }}
          />
        </th>
        <th colSpan={4} align="left">
          Review Date :
          {isView ? (
            formatDate(moduleData.review_date)
          ) : (
            <DatePickerMui
              label=""
              value={
                moduleData.review_date ? moment(moduleData.review_date) : null
              }
              onChange={(date: any) => {
                moduleData.review_date = date;
                setRender((prev) => !prev);
              }}
            />
          )}
        </th>
      </tr>
    </tfoot>
  );
};

export default TFoot;
